import { ApiService } from './../api.service';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
declare var swal: any;
@Injectable({ providedIn: 'root' })
export class CommonService {

	constructor(
		private apiService: ApiService
	) { }
	getActiveQps() {
		const activeQpsAPI = environment.nsdcCommonServiceUrl + '/api/nsdccommon/activeQPs';
		return this.apiService.get(activeQpsAPI);
	}

	// Borrowed qp listing

	// getBorrowedqp() {
	// 	const activeBorrowQpsAPI = environment.nsdcCommonServiceUrl + '/api/nsdccommon/activeQPs';
	// 	return this.apiService.get(activeBorrowQpsAPI);
	// }

	// end

	getEducationQualification() {
		const educationQualificationAPI = environment.nsdcCommonServiceUrl + '/api/nsdccommon/educationalqualifications';
		return this.apiService.get(educationQualificationAPI);
	}
	getRequiredExperience() {
		const experienceAPI = environment.nsdcCommonServiceUrl + '/api/nsdccommon/experiencerequired';
		return this.apiService.get(experienceAPI);
	}
	getEducationWithoutAuth() {
		const eduAPI = environment.nsdcCommonServiceUrl + 'api/nsdccommon/educationalqualifications/v1';
		return this.apiService.get(eduAPI);
	}

	getCasteCategories() {
		const url = `${environment.nsdcCommonServiceUrl}/api/nsdccommon/categories/v1`;
		return this.apiService.get(url);
	}

	getReligions() {
		const url = `${environment.nsdcCommonServiceUrl}/api/nsdccommon/religions/v1`;
		return this.apiService.get(url);
	}

	getDisabilities() {
		const url = `${environment.nsdcCommonServiceUrl}/api/nsdccommon/disability/v1`;
		return this.apiService.get(url);
	}
	getGender() {
		const url = `${environment.nsdcCommonServiceUrl}/api/nsdccommon/gender`;
		return this.apiService.get(url);
	}

	getSchemes() {
		const url = `${environment.nsdcCommonServiceUrl}/api/nsdccommon/nonpmkvyschemes`;
		return this.apiService.get(url);
	}

	confirmationSwal(type, extraParam?: any) {
		if (type === 'submit') {
			return swal({
				title: extraParam && extraParam.title ? extraParam.title : 'Are you sure,do you want to Submit?',
				type: 'info',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				cancelButtonColor: '#d33',
			})
		} else if (type === 'delete') {
			return swal({
				title: 'Are you sure,do you want to Delete?',
				type: 'warning',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				cancelButtonColor: '#d33',
			})
		} else if (type === 'covidSpace') {
			return swal({
				title: 'You are being re-directed to the login page/screen. Login with your SSDM Credentials to view the COVID Information Support',
				type: 'info',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				cancelButtonColor: '#d33',
			})
		} else if (type === 'edit') {
			return swal({
				title: 'Are you sure,do you want to Update?',
				type: 'warning',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				cancelButtonColor: '#d33',
			})
		} else if (type === 'enrollment') {
			if (extraParam === 1) {
				return swal({
					title: `Are You Sure,Do You want to Proceed Enrollment With ${extraParam} Candidate`,
					type: 'info',
					showCancelButton: true,
					cancelButtonText: 'Cancel',
					cancelButtonColor: '#d33',
				})
			} else if (extraParam > 1) {
				return swal({
					title: `Are You Sure,Do You want to Proceed enrollment With ${extraParam} Candidates`,
					type: 'info',
					showCancelButton: true,
					cancelButtonText: 'Cancel',
					cancelButtonColor: '#d33',
				})
			}

		} else if (type === 'ACCEPTED') {
			return swal({
				title: 'Are you sure, you want to Accept?',
				type: 'warning',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				cancelButtonColor: '#d33',
			})
		} else if (type === 'REJECTED') {
			return swal({
				title: 'Are you sure, you want to Reject?',
				type: 'warning',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				cancelButtonColor: '#d33',
			})
		} else if (type === 'assign') {
			return swal({
				title: 'Are you sure, you want to assign?',
				type: 'warning',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				cancelButtonColor: '#d33',
			})
		} else if (type === 'remove') {
			return swal({
				title: 'Are you sure, you want to remove?',
				type: 'warning',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				cancelButtonColor: '#d33',
			})
		}
		else if (type === 'enrolled') {
			return swal({
				title: `Are you sure, you want to enroll the selected ${extraParam} candidates`,
				text: 'You cannot enroll any candidates further in the batch after submission of candidate enrollment.',
				type: 'warning',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				cancelButtonColor: '#d33',
			})
		} else if (type === 'aadhaar') {
			return swal({
				title: `Aadhar Verification Failed Due To Invalid ${extraParam}`,
				text: "Click on below button to verify again with appropriate aadhaar type",
				icon: 'warning',
				showCancelButton: true,
				cancelButtonColor: '#5867dd',
				allowOutsideClick: false,
				confirmButtonText: 'Aadhar Reference ID',
				cancelButtonText: 'Aadhar Number',
				reverseButtons: true,
			})
		} else if (type === 'incomplete-profile') {
			return swal({
				title: `Enrollment Failure !`,
				text: `Please Complete Registration For Below Candidate ${extraParam}`,
				icon: 'warning',
				showCancelButton: false,
				cancelButtonColor: '#5867dd',
				allowOutsideClick: false,
				confirmButtonText: 'OK',
				reverseButtons: true,
			})
		}
	}

	successSwal(msg, type?) {
		swal(
			'',
			msg,
			type || 'success'
		)
	}
	swalNotification(msg, type) {
		swal(
			'',
			msg,
			type || 'success'
		)
	}

	getAllMastersForFinanceUser(type, pageNo, limit, filter?) {
		let query = {
			pageNo: pageNo,
			itemsPerPage: limit,
		}
		if (filter) {
			query = filter.batchId ? Object.assign({}, query, filter) : Object.assign({}, query);
			if (type && type === 'batche') {
				query = filter.batchCreation ? Object.assign({}, query, filter) : Object.assign({}, query);
				query = filter.schemeName ? Object.assign({}, query, filter) : Object.assign({}, query);
				query = filter.subSchemeName ? Object.assign({}, query, filter) : Object.assign({}, query);
				query = filter.tcId ? Object.assign({}, query, filter) : Object.assign({}, query);
				query = filter.tpId ? Object.assign({}, query, filter) : Object.assign({}, query);
				query = filter.trainingType? Object.assign({}, query, filter) : Object.assign({}, query);
			}
		}

		let masterUrl: any;
		switch (type) {
			case 'tp': masterUrl = `${environment.userServiceUrl}/api/nsdccommon/educationalqualifications/v1`;
				break;
			case 'tc': masterUrl = `${environment.userServiceUrl}/api/nsdccommon/educationalqualifications/v1`;
				break;
			case 'batche': masterUrl = `${environment.userServiceUrl}/api/batch/v1/list/masterBatches`;
				break;
			case 'sector': masterUrl = `${environment.userServiceUrl}/api/user/v1/masterSSC`;
				break;
		}
		return this.apiService.get(masterUrl, query);
	}
	tpPanRequest() {
		const url = `${environment.userServiceUrl}/api/user/v1/tp/pan/report`
		return this.apiService.getBlob(url, 'application/vnd.ms-excel');
	}

	getTpForRaisingDemands(query) {
		query && query['qpCode'] ? query['qpCode'] = encodeURIComponent(query['qpCode']) : delete query['qpCode'];
		const url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/dap/tcList?`
		return this.apiService.get(url, query);
	}

	raiseADemandByCandidate(payload) {
		const url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/dap/createDemand`
		return this.apiService.post(url, payload);
	}

	viewAllRaisedDemands(query) {
		const url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/dap/demandList?`
		return this.apiService.get(url, query);
	}

	getDemandStatus(data) {
		switch (data) {
			case 'DEMAND_RAISED': return 'Demand Raised'
			case 'DEMAND_ACCEPTED': return 'Demand Accepted'
			case 'DEMAND_REJECTED': return 'Demand Rejected'
			case 'DEMAND_EXPIRED': return 'Demand Expired'
			// case '': return
			// case '': return
			default: return data
		}
	}

	demandAction(payload) {
		const url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/dap/updateDemandStatus`
		return this.apiService.put(url, payload);
	}

	getBatchForRaisingDemands(query) {
		query && query['qpCode'] ? query['qpCode'] = encodeURIComponent(query['qpCode']) : delete query['qpCode'];
		const url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/dap/batchList?`
		return this.apiService.get(url, query);
	}
	getCovidQps() {
		const url = `${environment.userServiceUrl}/api/user/v1/getCovidqps`
		return this.apiService.get(url);
	}

	uploadNotice(payload, operation, id?) {
		let url = `${environment.userServiceUrl}/api/batch/v1/update/notice/details?op=${operation}`;
		if (id) {
			url = url.concat(`&id=${id}`)
		}
		return this.apiService.post(url, payload);
	}

	getNoticeList(pageNo, itemsPerPage) {
		const query = {
			pageNo: pageNo,
			itemsPerPage: itemsPerPage
		}
		const url = `${environment.userServiceUrl}/api/user/v1/noticeList`;
		return this.apiService.get(url, query);
	}

	getNoticeListOpen() {
		const url = `${environment.userServiceUrl}/api/user/v1/getNotice`;
		return this.apiService.get(url);
	}

	getSingleNoticeDetails(noticeId, pageNo, itemsPerPage) {
		const query = {
			id: noticeId,
			pageNo: pageNo,
			itemsPerPage: itemsPerPage
		}
		const url = `${environment.userServiceUrl}/api/user/v1/noticeList`;
		return this.apiService.get(url, query);
	}
	GetPasswordRecoveryRequest(pageNo?, itemsPerPage?) {
		const query = {
			pageNo: pageNo ? pageNo : '',
			itemsPerPage: itemsPerPage ? itemsPerPage : ''
		}
		const url = `${environment.userServiceUrl}/api/user/v1/GetPRRequest`;
		return this.apiService.get(url, query);
	}
	submitSupportTicket(payload) {
		let url = `${environment.userServiceUrl}/api/user/v1/supportTicket`;
		return this.apiService.post(url, payload);
	}

	getNoOfDaysBetweenTwoDates(toDate, fromDate) {
		if (fromDate && toDate) {
			let difference = new Date(toDate).getTime() - new Date(fromDate).getTime();
			let totalDays = Math.ceil(difference / (1000 * 3600 * 24));
			return totalDays + 1;
		}
	}


	getLanguages(){
		let url =  `${environment.utilityService}/api/utils/pmv/languageResource`
		return this.apiService.get(url);
	}

	getTrades(langcode){
		let url =  `${environment.utilityService}/api/utils/pmv/tradesBasedOnLang?targetLanguage=${langcode}`
		return this.apiService.get(url);
	}

}
